import redactSecretsOrig from 'redact-secrets';

const redactSecrets = (objectWithSecrets: Record<string, unknown>) => {
  return redactSecretsOrig('[REDACTED]').map(objectWithSecrets);
};

export default redactSecrets;
